import { useMemo } from 'react';
import { CopilotOutput } from 'libs/end-to-end/src/copilot';
import { CustomVizHookResult } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const useBasicCopilotData = ({
  result,
}: {
  result: CustomVizHookResult;
}) => {
  return useMemo(() => {
    return result.resultType === 'ok' && result.value
      ? CopilotOutput.parse(result.value)
      : null;
  }, [result]);
};
